module.exports = __webpack_public_path__ + "static/super-strong-cleanup-22038b71b97477be970b0987eb8d1ec7.jpg";